
import { SupportedLanguage } from "@/components/multilingual/LanguageSelector";

export interface CookieConsent {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  preferences: boolean;
}

export const defaultConsent: CookieConsent = {
  necessary: true,
  analytics: false,
  marketing: false,
  preferences: false
};

export const CONSENT_COOKIE_NAME = 'paperverse_cookie_consent';
export const LANGUAGE_COOKIE_NAME = 'paperverse_language';

// Translation types for better type safety
export interface CookieBannerTranslations {
  description: string;
  cookiePolicy: string;
  privacyPolicy: string;
  acceptAll: string;
  acceptEssential: string;
  close: string;
  cookieSettings: string;
  necessary: string;
  necessaryDescription: string;
  analytics: string;
  analyticsDescription: string;
  marketing: string;
  marketingDescription: string;
  preferences: string;
  preferencesDescription: string;
  save: string;
  and: string;
  all: string;
  essential: string;
  optional: string;
}

export interface LegalPageContent {
  title: string;
  text: string;
}

export interface CookieTableData {
  headers: string[];
  rows: string[][];
}

// Extended cookie table for detailed TDDDG/GDPR compliance
export interface DetailedCookieTableData {
  headers: string[];
  rows: {
    name: string;
    provider: string;
    purpose: string;
    category: string;
    duration: string;
    legalBasis: string;
  }[];
}

// Third-party provider disclosure for GDPR compliance
export interface ThirdPartyProviderData {
  name: string;
  purpose: string;
  country: string;
  transferBasis: string;
  privacyPolicyUrl: string;
}

// Anonymous tracking tier disclosure
export interface AnonymousTrackingData {
  title: string;
  description: string;
  legalBasis: string;
  dataCollected: string[];
}

// Consent-based tracking tier disclosure
export interface ConsentTrackingData {
  title: string;
  description: string;
  legalBasis: string;
  dataCollected: string[];
  storageMechanism: string;
}

export interface LegalPageTranslations {
  title: string;
  breadcrumb: string;
  version?: string; // Version tracking for consent
  content: LegalPageContent[];
  cookieTable?: CookieTableData;
}

// Extended cookie policy translations with TDDDG/GDPR compliance
export interface CookiePolicyTranslations extends LegalPageTranslations {
  detailedCookieTable?: DetailedCookieTableData;
  thirdPartyProviders?: ThirdPartyProviderData[];
  anonymousTracking?: AnonymousTrackingData;
  consentTracking?: ConsentTrackingData;
  controllerInfo?: {
    title: string;
    name: string;
    address: string;
    email: string;
    phone?: string;
  };
  withdrawalInfo?: {
    title: string;
    description: string;
    steps: string[];
  };
}

export interface LegalPagesTranslations {
  termsOfService: LegalPageTranslations;
  privacyPolicy: LegalPageTranslations;
  cookiePolicy: CookiePolicyTranslations;
  imprint: LegalPageTranslations;
  copyright: LegalPageTranslations;
}

export interface TranslationSchema {
  cookieBanner: CookieBannerTranslations;
  legalPages: LegalPagesTranslations;
}

export type TranslationsType = {
  [key in SupportedLanguage]: TranslationSchema;
};
